import Vue from 'vue'
import Vuex from 'vuex'
import AuthModule from './Auth/index.js'
import FranchiseModule from './Franchise/index.js'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
		dateFormat: process.env.VUE_APP_DATE_FORMAT
	},
    mutations: {},
    actions: {},
	getters: { getDate: (state) => state.dateFormat },
    modules: {
        Auth: AuthModule,
        Franchise: FranchiseModule
    }
})